import { useTextNoiseFill } from "./TextNoiseFillContext";
import { useMemo } from "react";
import { useSvgViewBoxZoom } from "../../hooks/useSvgViewBoxZoom";

export function TextNoiseFillViewer() {
    const {
        font,
        fontSize,
        viewBoxAttr,
        textCharacters,
        canExport,
        handleDownload,
    } = useTextNoiseFill();

    const base = useMemo(() => {
        const [x, y, w, h] = viewBoxAttr.split(" ").map(Number);
        return { x, y, w, h };
    }, [viewBoxAttr]);

    const {
        svgRef,
        viewBoxAttr: viewBox,
        panHandlers,
        zoomPercent,
        zoomIn,
        zoomOut,
        resetView,
    } = useSvgViewBoxZoom({ base });

    return (
        <div className="text-noise-fill-viewer">
            <div className="text-tool-preview">
                <div className="svg-zoom-controls">
                    <button
                        type="button"
                        className="zoom-button"
                        onClick={zoomOut}
                        title="Zoom out"
                    >
                        −
                    </button>
                    <span className="zoom-level">{zoomPercent}%</span>
                    <button
                        type="button"
                        className="zoom-button"
                        onClick={zoomIn}
                        title="Zoom in"
                    >
                        +
                    </button>
                    <button
                        type="button"
                        className="zoom-button"
                        onClick={resetView}
                        title="Reset zoom"
                    >
                        ⌂
                    </button>
                </div>
                <div className="svg-scroll-wrapper">
                    <div className="svg-container svg-container--fill">
                        <svg
                            ref={svgRef}
                            viewBox={viewBox}
                            xmlns="http://www.w3.org/2000/svg"
                            className="text-tool-svg"
                            style={{ touchAction: "none" }}
                            {...panHandlers}
                        >
                            <g className="text-fill">
                                {textCharacters.map((char, index) => (
                                    <text
                                        key={index}
                                        x={char.x}
                                        y={char.y}
                                        fontFamily={font}
                                        fontSize={fontSize}
                                        fill="black"
                                    >
                                        {char.char}
                                    </text>
                                ))}
                            </g>
                        </svg>
                    </div>
                </div>
                <div className="text-tool-footer">
                    <p className="text-tool-meta">
                        {textCharacters.length > 0
                            ? `Generated ${textCharacters.length} character${
                                  textCharacters.length === 1 ? "" : "s"
                              }.`
                            : "No characters generated."}
                    </p>
                    <button
                        type="button"
                        className="generic-button"
                        disabled={!canExport}
                        onClick={handleDownload}
                    >
                        Download result SVG
                    </button>
                </div>
            </div>
        </div>
    );
}
